import React from 'react'

const UsageReportFormatorSubcategory: React.FC = () => (
  <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.538452" width="70" height="70" rx="14.5455" fill="url(#paint0_linear_4674_17864)" />
    <g clipPath="url(#clip0_4674_17864)">
      <path
        d="M35.4004 33.109C35.5387 33.4192 35.7005 33.7183 35.8844 34.0037L50.3671 31.1224C49.7768 29.048 48.7719 27.1149 47.4132 25.44C46.0544 23.765 44.3701 22.3831 42.4621 21.3776C40.5541 20.3722 38.4619 19.7642 36.3122 19.5904C34.1625 19.4166 31.9999 19.6805 29.9551 20.3664L35.4004 33.109Z"
        fill="white"
      />
      <path
        d="M35.8413 37.8612C34.5784 36.8949 33.583 35.6223 32.9493 34.1638L27.5026 21.4132C25.4367 22.5045 23.6351 24.0354 22.2246 25.898C20.8141 27.7607 19.8289 29.9098 19.3385 32.1943C18.8482 34.4787 18.8644 36.8428 19.3862 39.1203C19.9079 41.3977 20.9225 43.5331 22.3585 45.3762C23.7945 47.2193 25.617 48.7252 27.6977 49.7881C29.7785 50.8509 32.0669 51.4447 34.4018 51.5278C36.7368 51.6109 39.0616 51.1812 41.2126 50.269C43.3637 49.3568 45.2886 47.9842 46.852 46.2478L35.8413 37.8612Z"
        fill="white"
      />
      <path
        d="M38.1536 36.2704L48.4749 44.1371C50.1243 41.5725 51.001 38.5876 51.0002 35.5384C50.998 34.9364 50.9619 34.335 50.8922 33.7371L38.1536 36.2704Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4674_17864"
        x1="35"
        y1="11.5385"
        x2="34.5455"
        y2="70.5385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E2EBD" />
        <stop offset="1" stopColor="#4A148C" />
      </linearGradient>
      <clipPath id="clip0_4674_17864">
        <rect width="32" height="32" fill="white" transform="translate(19 19.5385)" />
      </clipPath>
    </defs>
  </svg>
)

export default UsageReportFormatorSubcategory
